function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1f66b0d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./bookingApprovalLogs.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bookingApprovalLogs.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1f66b0d0\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bookingApprovalLogs.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f66b0d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/consoleBooking/bookingApprovalLogs.vue
// module id = 2047
// module chunks = 0